'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchIcon } from '../Search/SearchIcon';
import { styled } from '@mui/material/styles';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import { Popover, PopoverButton, PopoverContent } from '../Popover';
import { Search } from '../Search';
import { useHeaderState } from './HeaderStateContext';
import { headerCssClassNames } from './headerCssClassNames';
import clsx from 'clsx';
const StyledPopoverContent = styled(PopoverContent)({
    width: '100%'
});
export const HeaderSearch = React.forwardRef((_, ref) => {
    const { HeaderSearchProps, HeaderSearchButtonProps, isLaptop, isDesktop, isWideScreen } = useHeaderState();
    const inputRef = React.useRef(null);
    const popperModifiers = [
        {
            name: 'offset',
            options: {
                offset: [0, 6]
            }
        }
    ];
    const showDesktopSearch = isLaptop || isDesktop || isWideScreen;
    return (showDesktopSearch ? (_jsx(Search, { ...HeaderSearchProps, className: headerCssClassNames.searchInput, inputRef: inputRef, ref: ref, sx: {
            maxWidth: '14rem'
        }, variant: 'filled' })) : (_jsxs(Popover, { showClose: false, children: [_jsx(PopoverButton, { "aria-label": 'Search', ...HeaderSearchButtonProps, className: clsx(headerCssClassNames.searchMobileButton, 'FuelSearchButtonMobile'), component: IconButton, sx: {
                    ml: 'auto'
                }, children: _jsx(SearchIcon, {}) }), _jsx(StyledPopoverContent, { PaperProps: {
                    className: headerCssClassNames.searchPopover,
                    sx: (theme) => ({
                        boxShadow: 'none',
                        borderRadius: 0,
                        padding: theme.tokens.FuelSpacing4
                    })
                }, align: 'center', popperModifiers: popperModifiers, children: _jsx(Search, { ...HeaderSearchProps, className: headerCssClassNames.searchInput, inputRef: inputRef, ref: ref, variant: 'filled' }) })] })));
});
HeaderSearch.displayName = 'HeaderSearch';
